import React, { useState, useContext, useEffect, useCallback } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';

import { FeesContext } from '../../../LandlordFees';
import { getFeeTemplateHistory } from 'components/landlord_app/payments/store/actions';

import { showFailure } from 'actions/notificationActions';

import { Table } from 'ui-library/components/Table/Table';
import { Card, Typography, Table as RawTable } from 'antd';

import { basicSort } from 'ui-library/components/Table/TableSorter';

const StyledSectionContainer = styled.div`
  margin-bottom: 32px;
`;

const ExpandedRow = ({ record }) => {
  const [dataSource, setDataSource] = useState(null);

  if (record?.action === 'create') {
    return null;
  }

  const getDataSource = () => {
    return Object.keys(record.changes).map((k) => {
      const change = record.changes[k];
      // TODO - handle the foreign key cases (`charge_code_id` etc.)
      return {
        field: k,
        changed_from: change[0],
        changed_to: change[1],
      };
    });
  };

  if (!dataSource) {
    setDataSource(getDataSource());
  }

  return (
    <>
      {!!dataSource && (
        <RawTable
          size="small"
          pagination={false}
          columns={[
            {
              dataIndex: 'field',
              dataType: 'text',
              key: 'field',
              ellipsis: true,
              title: 'Field',
              width: '25%',
            },
            {
              dataIndex: 'changed_from',
              dataType: 'text',
              key: 'changed_from',
              ellipsis: true,
              title: 'Changed from',
            },
            {
              dataIndex: 'changed_to',
              dataType: 'text',
              key: 'changed_to',
              ellipsis: true,
              title: 'Changed to',
            },
          ]}
          dataSource={dataSource}
        />
      )}
    </>
  );
};

const History = () => {
  const feeData = useContext(FeesContext);
  const feeTemplateId = feeData.currentFeeTemplate.id;

  const [feeHistory, setFeeHistory] = useState(null);

  const [filteredInfo, setFilteredInfo] = useState(null);
  const [sortedInfo, setSortedInfo] = useState(null);

  const handleTableChange = (pagination, filters, sorter) => {
    setFilteredInfo(filters);
    setSortedInfo(sorter);
  };

  const loadHistory = useCallback(() => {
    getFeeTemplateHistory(feeTemplateId)
      .done((response) => {
        setFeeHistory(response.history);
      })
      .catch((error) => {
        showFailure(error);
      });
  }, [showFailure]);

  useEffect(() => {
    if (feeHistory === null) {
      loadHistory();
    }
  }, [feeHistory]);

  const handleResetButtonClick = () => {
    setSortedInfo(null);
    setFilteredInfo(null);
  };

  const isRowExpandable = (record) => {
    return Object.keys(record.changes).length > 0 && record.action !== 'create';
  };
  const columns = [
    {
      dataIndex: 'time',
      dataType: 'text',
      key: 'time',
      ellipsis: true,
      title: 'Date and time',
      width: '40%',
      sortOrder: sortedInfo?.columnKey === 'time' && sortedInfo?.order,
      sorter: (a, b) => basicSort(a.time, b.time),
    },
    {
      dataIndex: 'action ',
      dataType: 'text',
      key: 'action',
      ellipsis: true,
      title: 'Action',
      render: (text, rowData) => rowData.action,
    },
    {
      dataIndex: 'user',
      dataType: 'text',
      key: 'user',
      ellipsis: true,
      title: 'User',
      filteredValue: filteredInfo?.user || null,
    },
    {
      dataIndex: 'ip_address',
      dataType: 'text',
      key: 'ip_address',
      ellipsis: true,
      title: 'IP address',
      sortOrder: sortedInfo?.columnKey === 'ip_address' && sortedInfo?.order,
      sorter: (a, b) => basicSort(a.ip_address, b.ip_address),
      filteredValue: filteredInfo?.ip_address || null,
    },
  ];

  return (
    <Card>
      <StyledSectionContainer>
        <Typography.Title level={4}>History</Typography.Title>
        <Table
          loading={!feeHistory}
          dataSource={feeHistory || []}
          columns={columns}
          title={null}
          resetButtonOnClick={handleResetButtonClick}
          onChange={handleTableChange}
          expandedRowRender={(record) => <ExpandedRow record={record} />}
          rowExpandable={isRowExpandable}
        />
      </StyledSectionContainer>
    </Card>
  );
};

export default connect(null, { showFailure })(History);
